import React from "react";
import "../styles/PyramidTopBar.css";
type GameModeType = "Control" | "Edit" | "Debug" | "Run";
type MoveButtonType = "AB" | "AC" | "BC" | "BA" | "CA" | "CB" | "next" | null;
interface TopBarProps {
  GameMode: GameModeType;
  setGameMode: (value: GameModeType) => void;
  setMoveButton: (value: MoveButtonType) => void;
  Message: string;
  setisOpenPanel: (value: boolean) => void;
}
const buttonIcons = {
  Control: {
    default: "/img/button/control.svg",
    active: "/img/button/control_2.svg",
  },
  Edit: {
    default: "/img/button/edit.svg",
    active: "/img/button/edit_2.svg",
  },
  Debug: {
    default: "/img/button/debug.svg",
    active: "/img/button/debug_2.svg",
  },
  Run: {
    default: "/img/button/run.svg",
    active: "/img/button/run_2.svg",
  },
};
const TopBar: React.FC<TopBarProps> = ({
  GameMode,
  setGameMode,
  setMoveButton,
  Message,
  setisOpenPanel,
}) => {
  return (
    <div className="pyramid-top-bar-button">
      <div className="pyramid-top-bar">
        <div className="pyramid-button-setting">
          <img
            className="pyramid-icon"
            title="Управление"
            alt = "Управление"
            src={
              GameMode === "Control"
                ? buttonIcons.Control.active
                : buttonIcons.Control.default
            }
            onClick={() => setGameMode("Control")}
          ></img>
          <img
            className="pyramid-icon"
            alt="Программирование"
            title="Программирование"
            src={
              GameMode === "Edit"
                ? buttonIcons.Edit.active
                : buttonIcons.Edit.default
            }
            onClick={() => setGameMode("Edit")}
          ></img>
          {GameMode !== "Run" && (
            <img
              className="pyramid-icon"
              alt="Отладка"
              title="Отладка"
              src={
                GameMode === "Debug"
                  ? buttonIcons.Debug.active
                  : buttonIcons.Debug.default
              }
              onClick={() => setGameMode("Debug")}
            ></img>
          )}
          {GameMode !== "Debug" && (
            <img
              className="pyramid-icon"
              alt="Запуск"
              title="Запуск"
              src={
                GameMode === "Run"
                  ? buttonIcons.Run.active
                  : buttonIcons.Run.default
              }
              onClick={() => setGameMode("Run")}
            ></img>
          )}
        </div>
        <div className="pyramid-message-bar">
          <span>{Message}</span>
        </div>
        <img
          className="pyramid-icon help"
          alt="Помощь"
          title="Помощь"
          src="/img/help.svg"
          onClick={() => setisOpenPanel(true)}
        />
      </div>
      {GameMode !== "Debug" ? (
        <div className="pyramid-auxButtons" id="edit_buttons">
          <img
            src="/img/button/AB.svg"
            className="pyramid-icon"
            alt="AtoB"
            title="Прыгнуть с A на B"
            onClick={() => setMoveButton("AB")}
          />
          <img
            src="/img/button/BA.svg"
            className="pyramid-icon"
            alt="BtoA"
            title="Прыгнуть с B на A"
            onClick={() => setMoveButton("BA")}
          />
          <img
            src="/img/button/CA.svg"
            className="pyramid-icon"
            alt="CtoA"
            title="Прыгнуть с C на A"
            onClick={() => setMoveButton("CA")}
          />
          <img
            src="/img/button/AC.svg"
            className="pyramid-icon"
            alt="AtoC"
            title="Прыгнуть с A на C"
            onClick={() => setMoveButton("AC")}
          />
          <img
            src="/img/button/BC.svg"
            className="pyramid-icon"
            alt="BtoC"
            title="Прыгнуть с B на C"
            onClick={() => setMoveButton("BC")}
          />
          <img
            src="/img/button/CB.svg"
            className="pyramid-icon"
            alt="CtoB"
            title="Прыгнуть с C на B"
            onClick={() => setMoveButton("CB")}
          />
        </div>
      ) : (
        <div className="pyramid-nextButton">
          <img
            src="/img/button/next.svg"
            className="pyramid-next"
            alt="Next"
            title="Следующая команда"
            onClick={() => setMoveButton("next")}
          ></img>
        </div>
      )}
    </div>
  );
};
export default TopBar;
